import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatError } from "../../lib/api";
import { AdminTitle, AdminField, AdminCheck, Panel } from "./AdminUi";

export default function AdminPages() {
  const [pages, setPages] = useState([]);
  const [cur, setCur] = useState(null);
  const load = () => api.get("/admin/pages").then((r) => setPages(r.data));
  useEffect(() => { load(); }, []);
  const save = async () => {
    try { await api.put(`/admin/pages/${cur.slug}`, { title: cur.title, content: cur.content, validated: cur.validated }); toast.success("Page enregistrée"); load(); }
    catch (e) { toast.error(formatError(e)); }
  };
  return (
    <div data-testid="admin-pages">
      <AdminTitle title="Pages légales">Mise en forme : « ## Titre » pour un intertitre, « - » pour une liste. Les mentions [À compléter …] apparaissent en or.</AdminTitle>
      <div className="flex flex-wrap gap-2 mb-5">
        {pages.map((p) => (
          <button key={p.slug} onClick={() => setCur({ ...p })} className={`px-3 py-2 text-xs border ${cur?.slug === p.slug ? "bg-[#C9A45C] text-[#0B0B0B] border-[#C9A45C]" : "border-[#C9A45C]/30"}`} data-testid={`admin-page-${p.slug}`}>
            {p.title} {p.validated ? "✓" : "· provisoire"}
          </button>
        ))}
      </div>
      {cur && (
        <Panel className="p-5 space-y-4">
          <AdminField label="Titre" value={cur.title} onChange={(e) => setCur({ ...cur, title: e.target.value })} testid="page-form-title" />
          <AdminField textarea rows={20} label="Contenu" value={cur.content} onChange={(e) => setCur({ ...cur, content: e.target.value })} testid="page-form-content" />
          <AdminCheck label="Texte validé (retire la mention « version provisoire »)" checked={cur.validated} onChange={(v) => setCur({ ...cur, validated: v })} testid="page-form-validated" />
          <button onClick={save} className="btn-gold !py-3" data-testid="page-form-submit">Enregistrer</button>
        </Panel>
      )}
    </div>
  );
}
